import dayjs from "dayjs";
import {
  AccountMemberDetails,
  BuyFlowUser,
  PlanPackageUserFieldDetails,
  TenantUserFieldDetails,
  UserDetails,
  UserFields,
} from "features/types";

export const initial = (user?: UserDetails) => {
  if (!user) return "";
  return user.firstName.charAt(0) + user.lastName.charAt(0);
};

export const getUserName = (
  member: AccountMemberDetails | UserDetails | BuyFlowUser
): string => {
  if (member.hasOwnProperty("accountId")) {
    const {
      user: { firstName, lastName },
    } = member as AccountMemberDetails;
    return `${firstName} ${lastName}`;
  }
  const { firstName, lastName } = member as UserDetails;
  return `${firstName} ${lastName}`;
};

export const memberId = (value: number) => {
  const MAX_ID_LENGTH = 11;
  let memberIdString = Number(value).toString();
  const memberIdArray = memberIdString.padStart(MAX_ID_LENGTH, "0").split(""); // -> [0,0,0,0,0,0,0,1,2,3,4]
  memberIdArray[0] = "1";
  memberIdArray.splice(4, 0, "-");
  memberIdArray.splice(8, 0, "-");
  return memberIdArray.join("");
};

export const convertUserToUserFields = ({
  user,
  tenantOrPlanPackageUserFields,
}: {
  user: any;
  tenantOrPlanPackageUserFields: Array<
    TenantUserFieldDetails | PlanPackageUserFieldDetails
  >;
}) => {
  // serialzing user fields
  const fields = tenantOrPlanPackageUserFields.map((field) => field.field);
  const userFields: UserFields = {}; // to be added to primaryUser object
  fields.forEach((field) => {
    // skip blank fields: dayjs(undefined) is "now", so formatting a blank
    // DATE/DATETIME would silently submit today's date
    if (!user[field.name]) {
      return;
    }
    // convert date and datetime values to SQL format
    if (field.type === "DATE") {
      userFields[field.name] = dayjs(user[field.name]).format("YYYY-MM-DD");
    } else if (field.type === "DATETIME") {
      userFields[field.name] = dayjs(user[field.name]).format(
        "YYYY-MM-DD HH:mm:ss"
      );
    } else {
      userFields[field.name] = user[field.name];
    }
  });
  return userFields;
};
